import { ACTION_TRACKING_STATUS, AUDIT_REJECTED_UNREVIEWED, BUSINESS_REJECTED_UNREVIEWED, PROJECT_DOMAIN, REVIEWED_ACTION_COMPLETE, REVIEWED_ESCALATED, USER_ROLE } from '../constants/constants'

export const getButtonStatus = (role: any, opportunityStatus: any, anomalyStatus: string, projectParameters?:any) => {
    const domainName=projectParameters?.domainName || null;
    const prevAnomalyId=projectParameters?.prevAnomalyId || null;
    switch (role) {
        case USER_ROLE.ORG_USER:
            if(domainName === PROJECT_DOMAIN  && prevAnomalyId ===null){
                return false
            }
            let result = false;
            result = (opportunityStatus === 'accepted' || opportunityStatus === 'open' || opportunityStatus === 'rejected')
                && (anomalyStatus.toLowerCase() !== 'unreviewed') && anomalyStatus !== BUSINESS_REJECTED_UNREVIEWED && anomalyStatus !== AUDIT_REJECTED_UNREVIEWED;
            return result;
        case USER_ROLE.REVIEWER:{
            let resultReviewer = false;
            // if(domainName === PROJECT_DOMAIN ){
            //     return false
            // }
            // resultReviewer = opportunityStatus === 'open'  ;
            return resultReviewer;}
        case USER_ROLE.VIEWER:
            let resultViewer = false;
            return resultViewer;
        case USER_ROLE.POWER_USER:
            let resultPowerUser = false;
            return resultPowerUser;
        default:
            return false;
    }
}


export const getRightFooter = (params:any) => {     
    const roleName=params?.roleName || null;
    const prevAnomalyId=params?.prevAnomalyId || null;
    const domainName=params?.domainName || null;
    switch (roleName) {
        // case USER_ROLE.ORG_USER:{            
        //     return (prevAnomalyId !== null  && domainName !== PROJECT_DOMAIN);
        // }
        case USER_ROLE.REVIEWER: 
            return !(prevAnomalyId !== null  && domainName === PROJECT_DOMAIN)     
        default:
            return true;
    }
}

export const getCommentButton = (params:any) =>{   
    const roleName=params?.roleName || null;
    const domainName=params?.domainName || null;
    const detailedAnomalyStatus=params?.detailedAnomalyStatus || null;
    const prevAnomalyId=params?.prevAnomalyId || null;
    if(((roleName===USER_ROLE.REVIEWER ||roleName===USER_ROLE.ORG_USER) && domainName === PROJECT_DOMAIN &&
         [REVIEWED_ACTION_COMPLETE,REVIEWED_ESCALATED].includes(detailedAnomalyStatus)
          && prevAnomalyId === null)){
    return false
   }
   else return true
}


export const getMoreContextButtonStatus = (role: any, opportunityStatus: any, anomalyStatus: string,projectParameters?:any) => {
    const domainName=projectParameters?.domainName || null; 
    switch (role) {
        case USER_ROLE.ORG_USER:
            if(domainName === PROJECT_DOMAIN  && (anomalyStatus===REVIEWED_ESCALATED || anomalyStatus===REVIEWED_ACTION_COMPLETE  ) || anomalyStatus === BUSINESS_REJECTED_UNREVIEWED  || anomalyStatus === AUDIT_REJECTED_UNREVIEWED ){
                return false
            }
            let result = false;
            result = (opportunityStatus === 'accepted' || opportunityStatus === 'open' || opportunityStatus === 'rejected')
                && (anomalyStatus.toLowerCase() !== 'unreviewed');
            return result;
        case USER_ROLE.REVIEWER:{
            if(domainName === PROJECT_DOMAIN ){
                return false
            }
            let resultReviewer = false;
            resultReviewer = opportunityStatus === 'open';
            return resultReviewer;}
        case USER_ROLE.VIEWER:
            let resultViewer = true;
            return resultViewer;
        case USER_ROLE.POWER_USER:
        case USER_ROLE.ADMIN_USER:
            let resultPowerUser = true;
            return resultPowerUser;
        case USER_ROLE.DOMAIN_FOCAL:
            let resultDomainFocal = true;
            return resultDomainFocal;
        default:
            return false;
    }
}

export const getAuditAcceptButton = (role: any, opportunityStatus: any, auditLatestStatus: string,business_latest_status:string, anomalyStatus:string
    ) => {
    let resultPowerUser = "hidden";
    switch (role) {
        case USER_ROLE.ORG_USER:
            let result = "hidden";
            return result;
        case USER_ROLE.REVIEWER:
            let resultReviewer = "hidden";
            return resultReviewer;
        case USER_ROLE.VIEWER:
            let resultViewer = "hidden";
            return resultViewer;
        case USER_ROLE.POWER_USER:
        case USER_ROLE.ADMIN_USER:            
            if (opportunityStatus === "open") {
                if (auditLatestStatus == null) {
                    resultPowerUser = "hidden"
                } else { resultPowerUser = "disable" }
            } else if (auditLatestStatus === "audit-accept-orguser") {
                resultPowerUser = "disable";
            }
            else if (business_latest_status === "business-reject-reviewer" || business_latest_status === "business-reject-orguser") {
                resultPowerUser = "hidden";
            }else if(anomalyStatus === REVIEWED_ESCALATED){ 
                resultPowerUser ='hidden';
            }
            else {
                resultPowerUser = "visible";
            }
            return resultPowerUser;
        case USER_ROLE.DOMAIN_FOCAL:
            let resultDomainFocal = "hidden";
            if (opportunityStatus === "open") {
                if (business_latest_status === null) {
                    resultDomainFocal = "hidden"
                }
            } else if (business_latest_status === "business-accept-orguser") {
                resultDomainFocal = "disable";
            }
            else if (auditLatestStatus === "audit-reject-reviewer" || auditLatestStatus === "audit-accept-reviewer" || auditLatestStatus === "audit-reject-orguser" || auditLatestStatus === "audit-accept-orguser") {
                resultPowerUser = "hidden";
            }else if(anomalyStatus === REVIEWED_ESCALATED){ 
                resultPowerUser ='hidden';
            }
            else {
                resultDomainFocal = "visible";
            }
            return resultDomainFocal;
        default:
            return 0;
    }
}

export const displayReviewTask = (role: any, actionTrackingStatus: any) => {
    let enableActionTracking = false;
    if (actionTrackingStatus === ACTION_TRACKING_STATUS.INCOMPLETE ||
        actionTrackingStatus === ACTION_TRACKING_STATUS.PARTIALLY_COMPLETE ||
        actionTrackingStatus === ACTION_TRACKING_STATUS.ALL_COMPLETE || actionTrackingStatus === ACTION_TRACKING_STATUS.ORG_USER_COMPLETE ) {
        enableActionTracking = true;
    }

    switch (role) {
        case USER_ROLE.LEADERSHIP_USER:
            let result = "hidden";
            return result;
        case USER_ROLE.REVIEWER:
            let resultReviewer = "hidden";
            return resultReviewer;
        case USER_ROLE.VIEWER:
            let resultViewer = "hidden";
            return resultViewer;
        case USER_ROLE.ORG_USER:
            return enableActionTracking === true ? "visible" : "hidden";
        case USER_ROLE.POWER_USER:
        case USER_ROLE.ADMIN_USER:
            return enableActionTracking === true ? "visible" : "hidden";
        case USER_ROLE.DOMAIN_FOCAL:
            return enableActionTracking === true ? "visible" : "hidden";
        default:
            return 0;
    }
}

export const isPowerUser = (roles: any) => {
    if(roles[0] === USER_ROLE.POWER_USER || roles[0] === USER_ROLE.LEADERSHIP_USER){
        return true;
    }
    return false;
}

export const domainFocalUser = (roles: any) => {
    if (roles[0] === USER_ROLE.ORG_USER || roles[0] === USER_ROLE.DOMAIN_FOCAL){
        return true;
    }
    return false;
}

export const adminUser = (roles: any) => {
    if(roles && roles.length && roles.includes(USER_ROLE.ADMIN_USER)) {
        return true;
    }
    return false;
}

export const getReviewChecklistButton = (opportunityStatus:any,roleName:any,domainName:any) => {
    if( opportunityStatus === 'open' && roleName === USER_ROLE.REVIEWER&& domainName !== PROJECT_DOMAIN) {
        return true;
    }
    return false;
}

export const getPopUpHeaderTitle = (activeAction:any)=>{
   return activeAction === 'notes' ? "Activity"
    :activeAction === 'review-task' ? "Review Task"
    :activeAction === 'audit-reject' ? "Audit Reject"
    :activeAction === 'audit-accept' ? "Audit Accept"
    :activeAction === 'business-reject' ? "Business Reject"
    :activeAction === 'business-accept' ? "Business Accept"
    :activeAction === 'more-context' ? "Get More Context"
    :activeAction === 'tracking-submit' ? "Complete Task"
    :activeAction === 'accept' ? "What should be the corrective action?"
    :activeAction === 'reject' ? "No Action Required? Please provide remarks."
    :activeAction === 'share' ? "Share"
    :activeAction === 'share-via-email' ? "Share this anomaly in mail"
    :activeAction === 'reviewer-checklist' ? "Steps for successful anomaly review"
    :activeAction === 'acknowledge' ? "Acknowledged and actioning"
    :""
}